import Phaser from 'phaser';
import { MainScene } from './scenes/MainScene';
import { HubScene } from './scenes/HubScene';
import { RewardScene } from './scenes/RewardScene';
import { UIScene } from './scenes/UIScene';

const game = new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'game',
  scale: {
    mode: Phaser.Scale.RESIZE,
    width: '100%',
    height: '100%'
  },
  backgroundColor: '#080812',
  scene: [HubScene, MainScene, RewardScene, UIScene],
  physics: { default: 'arcade' },
  render: { pixelArt: false, antialias: true }
});

;(window as any).phaserGame = game;
